module.exports = __webpack_public_path__ + "static/img/son3.f60cc8d7.jpg";